// TODO: don't load jquery if already present on page

const accordionAnchors = {
    selector: null,
    triggerElement: null,

    init: function() {
        this.setSelector();
        this.setTriggerElement();
        this.scrollToTrigger();
    },

    setSelector: function() {
        const userHash = window.location.hash.replace(/[^\w-]/g, '');

        if (userHash.length < 1) {
            return;
        }
        
        const validAnchorPrefix = 'Item';
        
        if (userHash.indexOf(validAnchorPrefix) < 0) {
            return;
        }
        
        this.selector = `#${userHash}`;
    },

    hashElementExists: function() {
        if (this.selector === null) {
            return false;
        }

        const hashElement = $(this.selector);

        return hashElement.length > 0;
    },

    setTriggerElement: function() {
        if (this.hashElementExists() === false) {
            return;
        }

        const triggerElement = $(`a[href="${this.selector}"`);

        if (triggerElement.length < 1) {
            return;
        }

        this.triggerElement = triggerElement;
    },

    scrollToTrigger: function() {
        if (this.triggerElement === null) {
            return;
        }

        // open accordion item
        this.triggerElement[0].click();

        const container = $('html, body');

        const containerOffset = container.offset().top;
        const triggerOffset = this.triggerElement.offset().top;
        const scrollVal = triggerOffset - containerOffset + container.scrollTop();

        container.animate({ scrollTop: scrollVal}, 500);
    }
};


(function($) {
    accordionAnchors.init();
})(jQuery);
